import o from "@backmarket/design-tokens/backmarket.fonts";
import { designTokensVersion as s, designSystemVersion as t } from "./packageVersions.js";
const i = {
  version: t,
  tokens: {
    fontface: `https://static-ds.backmarket.com/fonts/v${s}/backmarket.fontface.css`,
    fonts: o.map(
      (e) => `https://static-ds.backmarket.com/fonts/v${s}/${e}`
    ),
    version: s
  }
}, m = t;
export {
  i as default,
  m as designSystemVersion
};
